module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-card', [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n                Select Type\n                "), (_vm.createEntity) ? _c('small', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.createEntity)))]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("\n                Data Input\n              ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3,
      "rules": [function () { return !this$1.error; }]
    }
  }, [_vm._v("Result")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "text-center",
    attrs: {
      "step": "1"
    }
  }, [_c('p', [_vm._v("Please choose if you want to create a new Customer or Contact.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseCreateEntity('customer')
      }
    }
  }, [_vm._v("new Customer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseCreateEntity('contact')
      }
    }
  }, [_vm._v("New Contact")])], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "text-center",
    attrs: {
      "step": "2"
    }
  }, [_c('p', [_vm._v("Please fill in the form in order to create a new " + _vm._s(_vm.createEntity) + ":")]), _vm._v(" "), (_vm.createEntity === 'customer') ? _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', [_vm._l((_vm.customerRequiredFields), function(item) {
    return _c('v-text-field', {
      key: item.key,
      attrs: {
        "label": item.key,
        "required": true,
        "rules": item.rules
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Show optional fields"
    },
    model: {
      value: (_vm.switchOptionals),
      callback: function($$v) {
        _vm.switchOptionals = $$v
      },
      expression: "switchOptionals"
    }
  })], 2), _vm._v(" "), (_vm.switchOptionals) ? _c('v-container', _vm._l((_vm.customerOptionalFields), function(item) {
    return _c('v-text-field', {
      key: item.key,
      attrs: {
        "label": item.key,
        "required": false,
        "placeholder": "Optional"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.createEntity === 'contact') ? _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', [_vm._l((_vm.contactRequiredFields), function(item) {
    return _c('v-text-field', {
      key: item.key,
      attrs: {
        "label": item.key,
        "required": true,
        "rules": item.rules
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Show optional fields"
    },
    model: {
      value: (_vm.switchOptionals),
      callback: function($$v) {
        _vm.switchOptionals = $$v
      },
      expression: "switchOptionals"
    }
  })], 2), _vm._v(" "), (_vm.switchOptionals) ? _c('v-container', _vm._l((_vm.contactOptionalFields), function(item) {
    return _c('v-text-field', {
      key: item.key,
      attrs: {
        "label": item.key,
        "required": false,
        "placeholder": "Optional"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.create($event)
      }
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": !!_vm.error
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success",
      "value": !_vm.error
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(_vm.createEntity)) + " successfully created\n                ")]), _vm._v(" "), (_vm.createEntity === 'customer' && !_vm.error) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.customerHeaders,
      "items": _vm.updated,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.customerId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customerName1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customerName2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.zipcode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.locationCode))])]
      }
    }], null, false, 1543502611)
  }) : _vm._e(), _vm._v(" "), (_vm.createEntity === 'contact' && !_vm.error) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.contactHeaders,
      "items": _vm.updated,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.contactId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactText1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactText2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.gepardCustomerNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactLocationCode))])]
      }
    }], null, false, 1524487963)
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-e5964224"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/CreateContactsCustomer.vue
// module id = 957
// module chunks = 1